<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>能力系统配置</span>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="解锁星星数">
              <el-input v-model.number="item.unlock_star" style="width: 100px;" placeholder="解锁星星数" />
            </el-form-item>
            <el-form-item label="语言KEY">
              <el-input v-model.number="item.lang_key" style="width: 150px;" placeholder="语言KEY" />
            </el-form-item>
            <el-form-item label="能力配置">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="langVisibleArr[index].visible = true" />
              <el-dialog :before-close="(d)=>{return handleClose(d, index)}" style="overflow-y: auto" title="能力配置" width="700px" :visible="langVisibleArr[index].visible">
                <el-form>
                  <el-row v-for="(r,i) in item.reward" :key="i">
                    <el-form-item label="能力类型" style="margin-top: 10px;">
                      <el-select v-model.number="r.type" style="width: 130px;" placeholder="请选择">
                        <el-option
                          v-for="item in capType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="能力" style="margin-top: 10px;">
                      <el-select v-model.number="r.ability" style="width: 130px;" placeholder="请选择">
                        <el-option
                          v-for="item in cateType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="数值" style="margin-top: 10px;">
                      <el-input v-model.number="r.num" style="width: 130px;" placeholder="数值" />
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                      <el-button v-if="item.reward.length > 1" v-permisaction="['config:taskCfg:add']" type="danger" @click="removeReward(index, i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-form-item>
                    <el-button v-permisaction="['config:area:add']" type="primary" @click="addReward(index)">+</el-button>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="langVisibleArr[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="langVisibleArr[index].visible = false">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:area:add']" type="danger" @click="del(item.id)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:area:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:area:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { delAbilityCfg, getAbilityCfgList, updateAbilityCfg } from '@/api/config/ability-cfg'
export default {
  name: 'CapacityConfig',
  data() {
    return {
      langVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      capType: [
        { label: '攻击收益', value: 1 },
        { label: '偷袭收益', value: 2 },
        { label: '租金目标显示数量', value: 3 },
        { label: '中级星星兑换宝箱冷却时间', value: 4 },
        { label: '高级星星兑换宝箱冷却时间', value: 5 },
        { label: '盾牌持有上限', value: 6 },
        { label: '随机卡收益', value: 7 },
        { label: '体力恢复时间', value: 8 },
        { label: '停车租金收益', value: 9 },
        { label: '冰块事件收益', value: 10 },
        { label: '地块事件收益', value: 11 },
        { label: '钻石事件收益', value: 12 },
        { label: '医院事件减低损失', value: 13 },
        { label: '禁停事件减低损失', value: 14 },
        { label: '签到收益', value: 15 },
        { label: '起点收益', value: 16 }
      ],
      cateType: [
        { label: '增加倍数', value: 1 },
        { label: '提高上限', value: 2 },
        { label: '增加额外收入', value: 3 },
        { label: '减少损失', value: 4 },
        { label: '减少冷却时间', value: 5 }
      ],
      formData: [
        {
          'id': 0,
          'unlock_star': 1,
          'reward': [
            { type: 1, ability: 1, num: 1 }
          ],
          'lang_key': ''
        }
      ] }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d, index) {
      this.langVisibleArr[index].visible = false
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateAbilityCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getAbilityCfgList(this.queryParams).then(res => {
        res.data.list.forEach((item, index) => {
          this.langVisibleArr.push({
            visible: false
          })
        })
        this.total = res.data.count
        this.formData = res.data.list
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'unlock_star': 1,
        'reward': [],
        'lang_key': ''
      })
      this.langVisibleArr.push({ visible: false })
    },
    del(id) {
      delAbilityCfg({ id: id }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addReward(index) {
      this.formData[index].reward.push({ type: 1, ability: 1, num: 1 })
    },
    removeReward(index, zIndex) {
      this.formData[index].reward = this.formData[index].reward.filter((item, i) => {
        return i !== zIndex
      })
    }
  }
}
</script>

<style scoped>
</style>
